import clsx from "clsx";
import { NavLink, Outlet } from "src/navigation";

function topLinkBar({isActive}: {isActive: boolean}) {
  return clsx(
    "px-4 py-3 font-medium",
    isActive ? "text-pcx-400 hover:text-pcx-500" : "text-pcx-400/40 hover:text-pcx-500"
  )
}

export function EpoImportMenu() {
  return (
    <>
      <div className="py-3">
        <NavLink className={topLinkBar} to="family">Family Scrape EPO</NavLink>
        <NavLink className={topLinkBar} to="excel">From Excel EPO Import</NavLink>
      </div>
      <Outlet />
    </>
  )
}